import {
  ConnectMoreAppsWidget,
  CreditBalanceWidget,
  PickUpWhereYouLeftOffWidget,
  TodaysRoutinesWidget,
  UpcomingMeetingsWidget,
  YesterdaysMeetingsWidget,
} from './widgets';

import type { SingletonWidgetId } from './widgets.types';
import type { ComponentType } from 'react';

export const widgetRegistry = {
  'upcoming-meetings': UpcomingMeetingsWidget,
  'todays-routines': TodaysRoutinesWidget,
  'yesterdays-meetings': YesterdaysMeetingsWidget,
  'pick-up-where-you-left-off': PickUpWhereYouLeftOffWidget,
  'connect-more-apps': ConnectMoreAppsWidget,
  'credit-balance': CreditBalanceWidget,
} satisfies Record<SingletonWidgetId, ComponentType>;
